import React, { useMemo, useState } from "react";
import { CheckOutlined, LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import SheriZeroCard from "assets/svg/sherizeroCard.svg";
import SheriCard from "assets/svg/sheriCard.svg";
import { useTranslation } from "contexts/TranslationContext";
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useLazyGetBusinessProviderAltQuery } from "services/lookup";
import BackButton from 'shared/components/BackButton/BackButton';
import routes, { appRoute } from 'shared/constants/routes';
import { Row, Col, Card, Button, Upload, Input, Form, Typography } from "antd";
import { toast } from "react-toastify";

const BestSellerimgPath = [
    {
        name: "Amazon SA",
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2F036030df864c1b9132357d8906163a47.png&w=3840&q=75'
    },
    {
        name: 'PUBG',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2FU7gzRDbcGrf4VIUDUhYjC2SwD5uZ9gNX07OaUdAS.jpeg&w=3840&q=75',
    },
    {
        name: 'Almatar',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_uwtirkcfgv_20-11-2023_at_01-26_PM.png&w=3840&q=75',
    },
    {
        name: 'Al Saif Gallery Card',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_mhepxuifwc_23-05-2024_at_07-46_AM.png&w=3840&q=75',
    },
]

const MerchantsimgPath = [
    {
        name: "Formula 1 stc Saudi Arabian Grand Prix Ticket",
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_qjiqvnvfup_26-03-2025_at_10-54_AM.png&w=3840&q=75'
    },
    {
        name: 'Almosafer',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_tkedjkbptg_20-05-2024_at_07-32_AM.jpeg&w=3840&q=75',
    },
    {
        name: 'Noon',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_cfjcejjxrp_25-04-2022_at_10-09_AM.png&w=3840&q=75',
    },
    {
        name: 'Eid Card',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_rgcwbvwwzg_03-04-2024_at_08-36_AM.jpeg&w=3840&q=75',
    },
    {
        name: 'Mrsool',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2F3nlIBY5sfvVjMQlXFxHoi5ySp0s95WJga8FeiCii.jpeg&w=3840&q=75',
    },
    {
        name: 'Resal Card',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_rocelaxtua_07-11-2022_at_11-51_AM.png&w=3840&q=75',
    },
    {
        name: 'Farm SuperStore',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2F88fa7b6741a3b15cabc1dc0f732256f6.png&w=3840&q=75',
    },
    {
        name: 'Saadeddin',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_gwizbouxbf_16-04-2023_at_12-15_PM.jpeg&w=3840&q=75',
    },
    {
        name: 'Hunger Station',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_yjhajdbolv_01-11-2022_at_11-00_AM.png&w=3840&q=75',
    },
    {
        name: 'Golden Scent',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_htdpwgolet_01-08-2023_at_11-38_AM.png&w=3840&q=75',
    },
    {
        name: 'Vogacloset',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2Fs7sYqoqlK7j0F3IZHnVjQHWAcZc6q7QfdLwMjEI4.jpg&w=3840&q=75',
    },
    {
        name: 'SAWA Recharge card',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2Fln9qN5RfblC5tKR3xTEVUZwDxBCm6AEV4zaPLNa6.jpeg&w=3840&q=75',
    },
    {
        name: 'Patchi',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_gcsymmowyj_17-09-2024_at_09-11_AM.jpeg&w=3840&q=75',
    },
    {
        name: 'Aani & Dani',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2FdZ58bVVHJE8xV8aaefaJW1QiIWCPI9RzcrCd6rq2.jpeg&w=3840&q=75',
    },
    {
        name: 'Shukran',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_ddkcxtibbs_12-01-2023_at_02-37_PM.png&w=3840&q=75',
    },
    {
        name: 'The Dockx Card',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_raubsjysid_04-12-2024_at_01-19_PM.png&w=3840&q=75',
    },
    {
        name: 'Nice One',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2Fv1wgySCVDEpm7GP4PSKEMk7ETs6KGIOtYKrZFr4Z.jpeg&w=3840&q=75',
    },
    {
        name: 'Almatar',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_uwtirkcfgv_20-11-2023_at_01-26_PM.png&w=3840&q=75',
    },
    {
        name: 'Al Saif Gallery Card',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_mhepxuifwc_23-05-2024_at_07-46_AM.png&w=3840&q=75',
    },
    {
        name: 'Hanan Abdulssalam',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_kzhwarrznf_24-03-2025_at_10-45_AM.jpeg&w=3840&q=75',
    },
    {
        name: 'Dina Al maghrabi',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_hhqmstgatd_24-03-2025_at_11-08_AM.jpeg&w=3840&q=75',
    },
    {
        name: 'Nora Alshemri',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_iggpovkosw_25-03-2025_at_08-12_AM.jpeg&w=3840&q=75',
    },
    {
        name: 'Johrh for Abaya',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2Fe3BwMJwLSWZ2ILlAOuzZQLIKCCga8qQ1wjvkZDHU.jpg&w=3840&q=75',
    },
    {
        name: 'Alothaim Tisatahel Card',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_uxieicuqqg_14-08-2023_at_07-22_AM.png&w=3840&q=75',
    },
    {
        name: 'Richy',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_jgimxsaojc_01-09-2024_at_07-05_AM.png&w=3840&q=75',
    },
    {
        name: 'Shaalan Al oun',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_ypttmgpvyx_24-03-2025_at_11-30_AM.jpeg&w=3840&q=75',
    },
    {
        name: 'SACO',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_obizokkjuo_18-12-2024_at_01-05_PM.png&w=3840&q=75',
    },
    {
        name: 'IBaloot',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2FmoAT40ADOk1zfrvOAXak9iCORTDbcNV14bZIsIzM.jpeg&w=3840&q=75',
    },
    {
        name: 'Shein',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2F1iokQlobvVae7BR4VFFatHCRTmdc3g8pvFuZWlmQ.jpeg&w=3840&q=75',
    },
    {
        name: 'Razer Gold',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2F4oUFM8bovr7ddfquPAttj1VQ1Rscv967AhCPg5Ls.jpeg&w=3840&q=75',
    },
    {
        name: 'Al Dawaa Gift Card',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_abwkvejkqm_05-05-2024_at_08-20_AM.png&w=3840&q=75',
    },
    {
        name: 'PSN',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2FWECClj95X6SzIjzQxdCZmwrEMz3F2BnTvCeKc0Br.jpeg&w=3840&q=75',
    },
    {
        name: 'Mobily',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2FyYDckvWuoP7WjP4ng9Fgbc2rkYb9vrYSjEOxIphV.jpeg&w=3840&q=75',
    },
    {
        name: 'Ramadan grocery card',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_fqikwkpuae_20-02-2025_at_01-40_PM.png&w=3840&q=75',
    },
    {
        name: 'PUBG',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Fs3.resal.me%2Fproducts%2Fattachments%2FU7gzRDbcGrf4VIUDUhYjC2SwD5uZ9gNX07OaUdAS.jpeg&w=3840&q=75',
    },
    {
        name: 'Gift card from Woosh',
        path: 'https://d29u1ihjhteljl.cloudfront.net/_next/image?url=https%3A%2F%2Fs3.amazonaws.com%2Finventoryms-prod%2Fimages%2Finventory_image_ylfvsetbsj_03-10-2024_at_10-43_AM.jpeg&w=3840&q=75',
    },

]


const SheriMerchants = () => {
    const navigate = useNavigate();
    const { translate, language } = useTranslation();
    const [merchants, setMerchants] = useState([]);
    const [visibleCount, setVisibleCount] = useState(24);
    const [searchTerm, setSearchTerm] = useState("");

    const isArabic = language?.code === "ar" ? true : false;

    useEffect(() => {
        const fetchMerchants = async () => {
            try {
                await getMerchants();
            } catch (error) {
                console.error('Error fetching merchants:', error);
                toast.error("Something went wrong while fetching merchants. Please try again.");
            }
        };
        fetchMerchants();
    }, [])



    const getMerchants = async () => {
        try {
            const response = await fetch('https://store-ms.resal.me/graphql', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: "query GetLandingPageImages($stores: [String!], $sortyBy: String, $category: String, $categories: [String!], $phrase: String, $acceptLanguage: String, $limit: Int, $offset: Int) { getLandingPage(stores: $stores, sortyBy: $sortyBy, category: $category, categories: $categories, phrase: $phrase, limit: $limit, offset: $offset, acceptLanguage: $acceptLanguage) { landing { cards { id  title\ntitleAr\ntitleEn\n images { id url color } } } } }"
                    ,
                    variables: {
                        phrase: "",
                        sortyBy: null,
                        category: null,
                        categories: [],
                        stores: [],
                        limit: 200,
                        offset: null,
                        acceptLanguage: "en"
                    }
                }),
            });
            if (!response.ok) {
                throw new Error('Failed to fetch merchants');
            }
            const data = await response.json();
            if (data) {
                setMerchants(data?.data?.getLandingPage?.landing?.cards);
            }
        } catch (error) {
            console.error('Error fetching merchants:', error);
            toast.error("Something went wrong while fetching merchants. Please try again.");
        }
    }

    const handleLoadMore = () => setVisibleCount(prev => prev + 24);

    const normalize = (text) => text?.toLowerCase().trim() || '';

    const normalizedSearch = normalize(searchTerm);

    const filteredMerchants = !normalizedSearch
        ? merchants
        : merchants.filter((item) => {
            return (
                normalize(item?.title).includes(normalizedSearch) ||
                normalize(item?.titleEn).includes(normalizedSearch) ||
                normalize(item?.titleAr).includes(normalizedSearch)
            );
        });


    return (
        <div className="rounded-xl mb-4 px-4 py-4 bg-white shadow-lg">
            <div className="flex justify-between items-center mb-4">
                <BackButton onClick={() => navigate(-1)} />
                <h2 className="text-2xl font-semibold">{translate('MERCHANTS.ALL_CARDS')}</h2>
                <div></div>
            </div>

            <div className="mb-4 flex justify-center">
                {isArabic ?
                    < div className="relative w-4/5">
                        <SearchOutlined className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500" size={20} />
                        <input
                            type="text"
                            placeholder={translate('MERCHANTS.SEARCH_BY_NAME')}
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setVisibleCount(24); // reset view count on new search
                            }}
                            className="w-full p-3 pr-12 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div> :
                    < div className="relative w-4/5">
                        <SearchOutlined className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500" size={20} />
                        <input
                            type="text"
                            placeholder={translate('MERCHANTS.SEARCH_BY_NAME')}
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setVisibleCount(24); // reset view count on new search
                            }}
                            className="w-full p-3 pl-12 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                }
            </div>

            {
                !searchTerm &&
                <div className="mt-8">
                    <h2 className="text-xl font-semibold">{translate('MERCHANTS.BEST_SELLERS')}</h2>
                    <div></div>
                    <Row gutter={[32, 32]} className="mt-2">
                        {BestSellerimgPath.map((item, index) => (
                            <Col span={6} key={index} xs={12} sm={12} md={6} >
                                <Card className="relative flex flex-col h-full p-4 md:p-5 rounded-xl"
                                    cover={
                                        <img alt={item.name} src={item.path} className="position: absolute; height: 100%; width: 100%; inset: 0px; color: transparent;"
                                            style={{ width: '100%', objectFit: 'contain' }} />
                                    }
                                >
                                    <Card.Meta title={item.name} />
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            }

            <div className="mt-8">
                <h2 className="text-xl font-semibold">{translate('MERCHANTS.PROVIDERS')}</h2>
                <div></div>
                <Row gutter={[32, 32]} className="mt-2">
                    {merchants.length !== 0 &&
                        filteredMerchants.slice(0, visibleCount).map((item, index) => (
                            <Col span={8} key={index}
                                xs={12}
                                sm={12}
                                md={8}
                            >
                                <Card id={item?.id} className="relative flex flex-col h-full p-4 md:p-5 rounded-xl"
                                    cover={
                                        // <div style={{ height: '270px', overflow: 'hidden', justifyContent: 'center', alignItems: 'center' }}>
                                        <img alt={item?.title} src={item?.images[0]?.url}
                                            className="position: absolute; height: 100%; width: 100%; inset: 0px; color: transparent;"
                                            style={{ width: '100%', objectFit: 'cover' }} />
                                        // </div>
                                    }
                                >
                                    {isArabic ?
                                        <Card.Meta title={item?.titleAr} />
                                        : <Card.Meta title={item?.titleEn} />

                                    }
                                </Card>
                            </Col>
                        ))
                    }
                </Row>

                {visibleCount < merchants.length && (
                    <div className="flex justify-center mt-6">
                        <button
                            onClick={handleLoadMore}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-xl shadow transition w-72 p-10"
                        >
                            Load More
                        </button>
                    </div>
                )}
            </div>
        </div >
    )

}

export default SheriMerchants;